import type {
  AnalyticsWidgetPageMessages,
  AnalyticsWidgetPageMessagesRequest,
  AnalyticsWidgetPages,
  AnalyticsWidgetPagesRequest,
} from './generated-api';
import { generatedApi } from './generated-api';

// The generated client exposes these POST reports as mutations. The analytics screen needs
// cached, argument-driven queries (skipToken, refetch on filter change), so they are
// declared here as queries on top of the generated types.
export const widgetPagesApi = generatedApi.injectEndpoints({
  endpoints: (build) => ({
    getWidgetPages: build.query<AnalyticsWidgetPages, AnalyticsWidgetPagesRequest>({
      query: (body) => ({ url: '/analytics/widget/pages', method: 'POST', body }),
    }),
    getWidgetPageMessages: build.query<
      AnalyticsWidgetPageMessages,
      AnalyticsWidgetPageMessagesRequest
    >({
      query: (body) => ({ url: '/analytics/widget/pages/messages', method: 'POST', body }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetWidgetPagesQuery, useGetWidgetPageMessagesQuery } = widgetPagesApi;
